import { RootState } from '../store'
import { createSelector } from '@reduxjs/toolkit'

const defaultAddress = {
  zip: '',
  city: '',
  state: '',
  addressLine1: '',
}

const getPrivateFoundation = (state: RootState) => state.privateFoundation.data
const getLoading = (state: RootState) => state.privateFoundation.loading

const makeFoundation = createSelector([getPrivateFoundation], (foundation) => {
  const {
    _id = '',
    einNumber = '',
    organizationUrl = '',
    organizationName = '',
    organizationDescription = '',
    organizationAddress = defaultAddress,
    contriPaidDsbrsChrtblAmt: disbursedCharitableAmount = 0,
    GrantOrContributionPdDurYrGrpAmt: contributedCharityAmount = 0,
  } = foundation

  const formattedDisbursedCharityAmount = disbursedCharitableAmount.toLocaleString('en-US')
  const formattedContributedCharityAmount = contributedCharityAmount.toLocaleString('en-US')

  return {
    _id,
    einNumber,
    organizationUrl,
    organizationName,
    organizationAddress,
    organizationDescription,
    contributedCharityAmount,
    disbursedCharitableAmount,
    formattedDisbursedCharityAmount,
    formattedContributedCharityAmount,
  }
})

export const PrivateFoundationSelectors = {
  getPrivateFoundation,
  getLoading,
  makeFoundation,
}
